import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
import { Units } from "@models/units.model";
import { UnitConverterService } from "@services/unit-converter.service";

export function LessThanMaximumValidator(units: Units, converterService: UnitConverterService): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let value = parseFloat(control.value);

    if (value > converterService.fromMeters(10000, units)) {
      return { 'smallerThanMaximum': true };
    }

    return null;
  }
}
